import { render } from "./PeriodoMultiselect.vue?vue&type=template&id=5dd829e1"
import script from "./PeriodoMultiselect.vue?vue&type=script&lang=js"
export * from "./PeriodoMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__